import { AirportCodes } from '../../../../types/airports';
import {
	AirportCodesWithMap,
	airportInteractiveMapUrl,
} from './airportInteractiveMapUrl';

function getIsAirportCodeWithMap(
	airport: AirportCodes,
): airport is AirportCodesWithMap {
	return airport in airportInteractiveMapUrl;
}

export const getAirportMapUrl = (airport: AirportCodes) => {
	if (!getIsAirportCodeWithMap(airport)) {
		throw new Error(`Invalid airport code: ${airport}`);
	}
	return airportInteractiveMapUrl[airport];
};

export const getAirportMapUrlForPoiId = (
	airport: AirportCodes,
	poiId?: string,
) => {
	if (!getIsAirportCodeWithMap(airport)) {
		throw new Error(`Invalid airport code: ${airport}`);
	}

	const airportMapUrl = airportInteractiveMapUrl[airport];

	if (poiId) return `${airportMapUrl.url}?poiId=${poiId}`;
	return airportMapUrl.url;
};
